/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-06-21",
    versionChannel: "nightly",
    buildDate: "2024-06-21T00:05:40.000Z",
    commitHash: "1164dd747a544efd10b088209a85f634eb202a0c",
};
